import React from 'react';

import useStyles from './styles';

interface Props {
    variant?: 'default' | 'danger';
    icon?: React.ReactNode;
    text: string;
    count?: number;
    compact?: boolean;
    className?: string;
}

const Label: React.FC<Props> = ({ variant = 'default', icon, text, count, compact, className }) => {
    const { classes, cx } = useStyles();
    return (
        <span
            className={cx(
                classes.root,
                {
                    [classes._danger]: variant === 'danger',
                    [classes._default]: variant === 'default',
                    [classes._compact]: compact
                },

                className
            )}
        >
            {icon ? <span className={classes.icon}>{icon}</span> : null}
            {text}
            {count ? <span className={classes.count}>{count}</span> : null}
        </span>
    );
};

export default Label;
